export default "__VITE_ASSET__9069761e__"